import React from "react";

import Framework from "@beardeddevops/react.framework";
import {Types} from "components";
import ObjectOverride from "components/ObjectOverride";

/**
 *  @property {Transactions_Collections_Object} state
 *  @property {object} model
 *  @property {Transactions_Collections_Properties} model.properties
 *  @property {Transactions_Collections_Is} model.is
 *  @property {Transactions_Collections_Has} model.has
 */
export default class Disposition_Enics_Status extends ObjectOverride {
	constructor(props) {
		super(props, Types.Transactions_Collections._name);
	}

	render = () => {
		// noinspection JSValidateTypes

		let {loading} = this.state;

		return (
			<div>
				<fieldset>
					<div className="row">
						<div className="col-md">
							<iframe
								id="enics"
								className="hidden-xs hidden-sm"
								src="https://www.cjis.gov/CJISEAI/EAIController"
								style={{
									minWidth: "1050px",
									border: "none",
									overflow: "scroll",
									width: "100%",
									height: "1000px",
									scrolling: "yes",
								}}
								frameBorder="0"
							/>
						</div>
					</div>
				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		);
	};
}
